module.exports = __webpack_public_path__ + "img/edasneo-icon.f20a90f8.png";